import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson } from '@client/core/data/concerns/parses-from-json';
import { snakeCaseKeys } from '@client/core/utils/snake-case-keys';
import { ShareLink } from '@client/features/share-link/models/share-link';
import { JsonResponse } from '@client/core/http/types';

export class ShareLinkDataSource extends DataSource {
  async store(data: { projectId: number; endpoint: string }): Promise<ShareLink> {
    const response = await this.httpClient.post<JsonResponse>('/share-links', snakeCaseKeys(data));

    return fromJson(ShareLink, response.data.data);
  }

  async destroy({ projectId, endpoint }: { projectId: number; endpoint: string }): Promise<void> {
    await this.httpClient.delete(`/share-links/${projectId}/${endpoint}`);
  }
}
